/**!
 * Created by Leonardo Cheslacki on 03/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import config from '../../../../config';

const {default: {init, audio}, menu: {index}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class PageMain extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            disabled: false,
            enabled: false,
            confirm: false,
            element: null
        };

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handleStart: function (event) {
            _this.stopPropagation(event);
            _this.getFrame().gotoAndPlay('complete');
        },

        /**
         *
         * @param event
         */
        handleBack: function (event) {
            _this.stopPropagation(event);

            const
                element = _this.getElementById('load_iframe'),
                {name, frame} = _this.getDefaultIndex();

            _this.gotoAndStopFrame(_this.get(), init.frame);
            _this.getFrame().gotoAndPlay('start');

            _this.main.$current_name = name;
            _this.main.$current_frame = frame;
            _this.main.$current_name_sub = null;
            _this.main.$current_frame_sub = null;

            element && element.wantDisabled(true);
            element.setAttribute('src', _this.getUriSource(_this.main.$current_name));
        },

        /**
         *
         * @param event
         * @param current_name
         * @param current_frame
         * @param btn
         * @returns {*}
         */
        handlePaginate: function (event, {current_name, current_frame, btn}) {
            if (init.marker) {
                _this.markerOut();

                _this.pageOut();

                _this.main.$current_name = current_name;
                _this.main.$current_frame = current_frame;
                _this.main.$current_name_sub = null;
                _this.main.$current_frame_sub = null;
            } else {
                _this.markerSliderAnimate(btn);

                _this.pageOut();

                _this.main.$current_name = current_name;
                _this.main.$current_frame = current_frame;
                _this.main.$current_name_sub = null;
                _this.main.$current_frame_sub = null;
            }
        },

        /**
         *
         * @param event
         * @param current_name
         * @param current_frame
         * @returns {*}
         */
        handlePaginateSub: function (event, {current_name, current_frame}) {
            _this.pageOut();

            _this.main.$current_name_sub = current_name;
            _this.main.$current_frame_sub = current_frame;
        }
    };

    startPaginate = () => {
        const
            object = this.getCurrentIndex(),
            paginates = _this.getObject(object, 'paginates');

        if (this.isArrayIf(paginates)) {
            let _this_current = this.get(this.main.$current_name);

            for (let property of paginates) {
                let
                    name = this.getObject(property, 'name'),
                    frame = this.getObject(property, 'frame'),
                    occ = this.padWithLeadingZeros(frame, 2),
                    btn = this.verifyField(_this_current, `btn_page${occ}`);

                if (this.getObject(property, 'default')) {
                    this.main.$default_page_sub = () => {
                        this.$functions.handlePaginateSub(undefined, {current_name: name, current_frame: occ});
                    };
                    this.main.$current_name_sub = name;
                    this.main.$current_frame_sub = frame;
                }

                let handle_name = this.toHandleName(occ, 'paginate_sub');

                if (btn) {
                    this[handle_name] && btn.off('mousedown', this[handle_name]);
                    this[handle_name] = btn.on('mousedown', this.$functions.handlePaginateSub, false, false, {
                        current_name: name,
                        current_frame: frame
                    });
                }
            }
        }
    };

    startIndex = () => {
        if (this.isArrayIf(index)) {
            let _this_frame = this.getFrame();

            for (let property of index) {
                let
                    name = this.getObject(property, 'name'),
                    frame = this.getObject(property, 'frame'),
                    occ = this.padWithLeadingZeros(frame, 2),
                    btn = _this_frame[`btn_page${occ}`];

                if (this.getObject(property, 'default')) {
                    this.main.$default_page = () => {
                        this.$functions.handlePaginate(undefined, {
                            current_name: name,
                            current_frame: occ,
                            btn: btn
                        });
                    };
                    this.main.$current_name = name;
                    this.main.$current_frame = frame;
                }

                let handle_name = this.toHandleName(occ, 'paginate');

                this[handle_name] && btn.off('mousedown', this[handle_name]);
                this[handle_name] = btn.on('mousedown', this.$functions.handlePaginate, false, false, {
                    current_name: name,
                    current_frame: frame,
                    btn: btn
                });
            }
        }
    };

    startBefore = () => {
        const
            _this_frame = this.getFrame(),
            {btn_start} = _this_frame;

        _this_frame.gotoAndPlay('start');

        this.setHandleMouseDown(btn_start, this.$functions.handleStart);
    };

    initIndex = () => {
        const
            {current_name} = this.props,
            _this_current = this.get(),
            element = this.getElementById('load_iframe'),
            {frame} = this.getDefaultIndex();

        Boolean(init.fullscreen) && !this.isMobile() && this.fullScreen();

        if (Boolean(init.before)) {
            element && element.wantDisabled(true);
            this.gotoAndStopFrame(_this_current, init.frame);
            this.startBefore();
        } else {
            element && element.wantDisabled(false);
            this.gotoAndStopFrame(_this_current, frame);
            this.main.$current_frame = frame;
            this.logo();
            init.marker ? this.markerIn() : this.markerSliderIn();
            this.backgroundDynamic();
            this.startIndex();
        }

        // this.removeListener('load', 'load-iframe', () => {
        //     this.addListener(element, 'load', 'load-iframe', () => {
        //         console.log('load-iframe');
        //     });
        // });

        /**
         * On of emit current_name index, correspond all animate_complete.
         */
        this.main.on('animate_complete', () => {
            const
                object = this.getCurrentIndex(),
                paginates = _this.getObject(object, 'paginates');

            if (this.getObject(object, 'type') === 'audio') {
                const playAudio = () => {
                    if (!audio.all) {
                        this.pauseAudio(() => {
                            this.readAudio(this.getObject(object, 'uri'));
                        });
                    } else {
                        !this.checkAudio() && this.readAudio(this.getObject(object, 'uri'));
                    }
                };

                this.setState({...this.state, enabled: false}, playAudio);

                this.main.on('play_audio', playAudio, 'confirm_play_audio');
            } else {
                !audio.all && this.pauseAudio();
            }

            _this.isArrayIf(paginates) && this.startPaginate();

        }, current_name);

        /**
         * On of emit current_name index, correspond all animate_end.
         */
        this.main.on('animate_end', ({current_name}) => {
            /**
             * Provisional
             */
            const {document} = window.top;

            let element_menu = document.getElementById('load_iframe_menu');

            if (element_menu) {
                element_menu.remove();
                element_menu = null;
            }
            /**
             * End Provisional
             */

            if (current_name === 'index') {
                element && element.wantDisabled(false);
                this.gotoAndStopFrame(this.get(), frame);
                this.main.$current_frame = frame;
                this.logo();
                init.marker ? this.markerIn() : this.markerSliderIn();
                this.backgroundDynamic();
                this.startIndex();

                if (Boolean(init.before)) {
                    const {btn_back} = this.getFrame();

                    btn_back.visible = true;

                    this.setHandleMouseDown(btn_back, this.$functions.handleBack);
                }
            } else {
                const object = this.getCurrentIndex();

                if (this.isEmpty(this.main.$current_name_sub)) {
                    this.logo();
                    init.marker ? this.markerIn() : this.markerSliderIn();
                    this.backgroundDynamic();
                }

                if (this.getObject(object, 'type') === 'audio') {
                    this.readAudio(this.getObject(object, 'uri'));
                }

                switch (this.getObject(object, 'type')) {
                    case 'video':
                        this.checkAudio() && this.pauseAudio();
                        element && element.wantDisabled(true);
                        this.openVideo(null, object);
                        break;
                    case 'tour':
                        element && element.wantDisabled(true);
                        this.openTour(null, object);
                        break;
                    case 'external':
                        element && element.wantDisabled(true);
                        this.openExternal(null, object);
                        break;
                    case 'paginate':
                        element && element.wantDisabled(false);

                        const
                            paginates = this.getObject(object, 'paginates'),
                            paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

                        this.main.$current_name_sub = this.getObject(paginate, 'name');

                        /**
                         * Provisional
                         */
                        let menu = this.getObject(paginate, 'menu');

                        if (!element_menu && menu) {
                            let element_iframe = document.createElement('IFRAME');
                            element_iframe.setAttribute('src', `${this.$base_uri}/src/menu/menu.html`);
                            element_iframe.setAttribute('id', 'load_iframe_menu');
                            element_iframe.setAttribute('allowfullscreen', '0');
                            element_iframe.setAttribute('scrolling', 'no');
                            element_iframe.setAttribute('frameborder', '0');
                            anim_container.prepend(element_iframe);
                        }
                        /**
                         * End Provisional
                         */

                        element.contentWindow.location.replace(this.getUriSource(this.main.$current_name, `${this.main.$current_name_sub}/${this.main.$current_name_sub}`));
                        break;
                    default:
                        element && element.wantDisabled(false);
                        element.contentWindow.location.replace(this.getUriSource(this.main.$current_name));
                }
            }
        }, current_name);
    };
}

/**
 *
 * @type {{}}
 */
PageMain.propTypes = {
    current_name: PropTypes.string
};

/**
 *
 * @type {{}}
 */
PageMain.defaultProps = {
    current_name: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageMain, {className: 'PageMain'});
